export default __webpack_public_path__ + "static/media/Spectral-ExtraBold.81a643ce.woff";